import type { MantineTheme } from '@mantine/core';
import type { CSSObject } from '@emotion/react';
export const BILLER_CLAIM_COLUMN_ORDER = [
  'serviceStart',
  'claimNumber',
  'providerID',
  'tariffs',
  'status',
  'payorID',
  'debits.requestedAmount',
  'debits.paidAmount',
  'debits.eobs',
];

export const BILLER_CLAIMS_CLASS_NAMES = {
  page: 'biller-claims',
  totals: 'biller-claims-totals',
} as const;

export const BILLER_CLAIMS_METRICS = {
  actionHeight: 34,
  controlPadding: 8,
  actionPadding: 12,
  actionRadius: 8,
  totalsRadius: 12,
  iconSize: 16,
  fontSize: { body: 13, caption: 11, micro: 10 },
} as const;

export const getBillerClaimsStyles = (
  theme: MantineTheme,
  colorScheme: 'light' | 'dark'
): CSSObject => ({
  [`.${BILLER_CLAIMS_CLASS_NAMES.page}`]: {
    '--biller-surface': 'var(--mantine-color-body)',
    '--biller-sunken': theme.colors[`surface-${colorScheme}`][0],
    '--biller-border': 'var(--mantine-color-default-border)',
    "& [data-testid='claimsManagement-title']": {
      fontSize: 'clamp(1.5rem, 2.4vw, 2.125rem)',
      fontWeight: 700,
      letterSpacing: '-0.02em',
      lineHeight: 1.2,
    },
    '& .claims-toolbar-group': {
      gap: BILLER_CLAIMS_METRICS.controlPadding,
    },
    '& .claims-toolbar-group .mantine-Button-root': {
      height: BILLER_CLAIMS_METRICS.actionHeight,
      paddingInline: BILLER_CLAIMS_METRICS.actionPadding,
      border: '1px solid var(--biller-border)',
      borderRadius: BILLER_CLAIMS_METRICS.actionRadius,
      fontSize: BILLER_CLAIMS_METRICS.fontSize.body,
      fontWeight: 600,
    },
    '& .claims-toolbar-group .mantine-Button-root:not(:disabled)': {
      background: 'var(--biller-surface)',
      color: 'var(--mantine-color-text)',
    },
    '& .claims-toolbar-group .mantine-Button-root:not(:disabled):hover': {
      background: 'var(--biller-sunken)',
    },
    '& .claims-toolbar-group svg': {
      width: BILLER_CLAIMS_METRICS.iconSize,
      height: BILLER_CLAIMS_METRICS.iconSize,
    },
    "& .claims-toolbar-group [data-testid='upload-family-medicine-button']": {
      width: BILLER_CLAIMS_METRICS.actionHeight,
      padding: '0',
    },
    '& button:focus-visible, & input:focus-visible': {
      outline: '2px solid var(--mantine-primary-color-filled)',
      outlineOffset: '2px',
    },
  },
  [`.${BILLER_CLAIMS_CLASS_NAMES.totals}`]: {
    flex: '0 1 430px',
    maxWidth: '100%',
    borderRadius: BILLER_CLAIMS_METRICS.totalsRadius,
    '& > :first-of-type': {
      padding: '7px 11px',
    },
    '& > :first-of-type .mantine-Text-root': {
      fontSize: BILLER_CLAIMS_METRICS.fontSize.caption,
      color: 'var(--mantine-color-dimmed)',
      lineHeight: 1.4,
    },
    '& .mantine-SimpleGrid-root > div': {
      minWidth: 0,
      padding: '7px 11px',
      gap: '1px',
    },
    '& .mantine-SimpleGrid-root .mantine-Text-root:first-of-type': {
      fontSize: BILLER_CLAIMS_METRICS.fontSize.micro,
      letterSpacing: '0.07em',
    },
    "& [data-testid^='claims-total-']": {
      fontSize: '15px',
      fontVariantNumeric: 'tabular-nums',
      letterSpacing: '-0.01em',
      overflowWrap: 'anywhere',
    },
  },
});
